import { PayPasswordErrorType } from './constant';
import { objectToQuery } from '@mx/util/object-to-query';
import { compareVersion } from '@mx/util/compare-version';

/**
 * 字符串反转
 * @param s
 */
export function reverseString(s: string) {
  return s.split('').reverse().join('');
}

/**
 * 支付密码校验
 * @param paypass 支付密码
 */
export function checkPayPassword(paypass: string) {
  const repeatedReg = /(\d)\1{5}/;
  const completelyContinuous = [
    '012345',
    '123456',
    '234567',
    '345678',
    '456789',
    '543210',
    '654321',
    '765432',
    '876543',
    '987654',
  ];

  if (repeatedReg.test(paypass)) {
    return {
      type: PayPasswordErrorType.MPM_PAY_PASSWORD_COMPLETELY_REPEATED,
      message: '请不要设置完全重复的数字',
    };
  }
  if (completelyContinuous.indexOf(paypass) > -1) {
    return {
      type: PayPasswordErrorType.MPM_PAY_PASSWORD_COMPLETELY_CONTINUOUS,
      message: '请不要设置完全连续的数字',
    };
  }
  return {
    type: '',
    message: '',
  };
}

/**
 * 判断设备是否支持面容 ID
 * @param model 设备 model 类型
 */
export function isSupportFaceID(env: EnvParms) {
  let model = env.commonParams.nb_device_model;
  const nb_version = env.commonParams.nb_version;
  let isFaceIDDevice = false;
  // 如果 sdk 版本大于 10.6.0，则使用 pay.getBiometricsInfo 桥提供的 support_faceid 参数，判断设备是否支持面容
  if (compareVersion(nb_version, '10.6.0') >= 0) {
    const support_faceid = env.biometricsInfoParams.support_faceid;
    isFaceIDDevice = !!support_faceid;
  } else {
    if (model) {
      model = model.toLowerCase().trim();
      // TODO: https://theapplewiki.com/wiki/List_of_iPhones#iPhone_SE_(2nd_generation)
      // 之后可按照这个列表,iphoneXR之后的版本除去SE的两个版本,都支持
      const list = [
        // !!!!!!小写小写
        // tslint:disable-next-line:max-line-length
        'iphone xs',
        'iphone xs max',
        'iphone xr',
        'iphone x',
        'iphone 11',
        'iphone 11 pro max',
        'iphone 11 pro',
        'iphone 12',
        'iphone 12 pro',
        'iphone 12 pro max',
        'iphone 12 mini',
        'iphone 13 pro',
        'iphone 13 pro max',
        'iphone 13 mini',
        'iphone 13',
        'iphone 14',
        'iphone 14 plus',
        'iphone 14 pro',
        'iphone 14 pro max',
        'iphone 15',
        'iphone 15 plus',
        'iphone 15 pro',
        'iphone 15 pro max'
      ];
      // tslint:disable-next-line:max-line-length
      const deviceList = [
        'iphone10,3',
        'iphone10,6',
        'iphone11,2',
        'iphone11,4',
        'iphone11,6',
        'iphone11,8',
        'iphone12,1',
        'iphone12,3',
        'iphone12,5',
        'iphone13,2',
        'iphone13,3',
        'iphone13,4',
        'iphone13,1',
        'iphone14,2',
        'iphone14,3',
        'iphone14,4',
        'iphone14,5',
        'iphone14,7',
        'iphone14,8',
        'iphone15,2',
        'iphone15,3',
        'iphone15,4',
        'iphone15,5',
        'iphone16,1',
        'iphone16,2'
      ];
      if (list.indexOf(model) > -1 || deviceList.indexOf(model) > -1) {
        isFaceIDDevice = true;
      }
      // tslint:disable-next-line:max-line-length
      // const ipadList = ['ipad pro 3 (11 inch, wifi)', 'ipad pro 3 (11 inch, wifi+cellular)', 'ipad pro 3 (11 inch, wifi+cellular)', 'ipad pro 3 (12.9 inch, wifi)', 'ipad pro 3 (12.9 inch, wifi)',
      // tslint:disable-next-line:max-line-length
      //     'ipad pro 3 (12.9 inch, wifi+cellular)', 'ipad pro 3 (12.9 inch, wifi+cellular)', 'ipad pro (11 inch, 2nd generation)', 'ipad pro (11 inch, 2nd generation)', 'ipad pro (12.9 inch, 4nd generation)', 'ipad pro (12.9 inch, 4nd generation)'];
      // tslint:disable-next-line:max-line-length
      // const ipadDeviceList = ['ipad8,1', 'ipad8,2', 'ipad8,3', 'ipad8,4', 'ipad8,5', 'ipad8,6', 'ipad8,7', 'ipad8,8', 'ipad8,9', 'ipad8,10', 'ipad8,11', 'ipad8,12'];
      // if (ipadList.indexOf(model) > -1 || ipadDeviceList.indexOf(model) > -1) {
      //     isFaceIDDevice = true;
      // }
    }
  }
  return isFaceIDDevice;
}

/**
 * url 后边拼接参数
 * @param url 待拼接的 url
 * @param query 待拼接的参数
 */
export function contactJumpLink(url: string, query = {}): string {
  if (url.indexOf('http') === 0) {
    const mark = url.indexOf('?') > 0 ? '&' : '?';
    return `${url}${mark}${objectToQuery(query)}`;
  }
  return url;
}
